import ApiService from '@/services/api.service'

const ISetupService = {

  /*  ---------------------------------------------------   Setup Users  -----------------------------------------------------------------------  */
    getAllUsers(parameter) {              
          const requestData = {
            method: 'get',
            url: "/SetupUsers",
            headers: {
            },
            params: { 
              SearchCriteria: parameter.SearchCriteria,
              EmployeeTypeCode:parameter.EmployeeTypeCode,
              RoleCode:parameter.RoleCode,
              //ProviderCode:parameter.ProviderCode
              PageSize: parameter.PageSize,          
              PageNumber : parameter.PageNumber,           
            }
          }     
          return ApiService.customRequest(requestData);         
        },
        
      UpdateUser(id,data){
        return ApiService.put(`/SetupUsers/${id}`,data);
      },
      AddUser(user){
        return ApiService.post(`/SetupUsers/`,user);
      },
      GetUser(id){
        return ApiService.get(`/SetupUsers/${id}`);
      },
      DeleteUser(id){
        return ApiService.delete(`/SetupUsers/${id}`);
      },

      getInfoByNPIUser(npi){
        return ApiService.get(`/SetupUsers/npi/${npi}`);
      },

/*  ---------------------------------------------------   Setup Company  --------------------------------------------------------------------------- */
      getAllCompanies(){        
         return ApiService.get(`/SetupCompanies`);
      },

      AddCompany(company){
        return ApiService.post(`/SetupCompanies/`,company);
      },

      UpdateCompany(id,data){
        return ApiService.put(`/SetupCompanies/${id}`,data);
      },

      getInfoByNPICompany(npi){
        return ApiService.get(`/SetupProviders/npi/${npi}`);
      },


      /*  -----------------------------------------------  Setup Providers  ------------------------------------------------------------------------- */ 

      getAllSetupProviders(){        
         return ApiService.get(`/SetupProviders`);
      },

      GetSetupProvider(id){
        return ApiService.get(`/SetupProviders/${id}`);
      },

      UpdateProvider(id,data){
        return ApiService.put(`/SetupProviders/${id}`,data);
      },

      /**----------------------------------------------- Setup Referral ----------------------------------------------------------------------------- */

      getAllReferral(parameter){                 
          const requestData = {
            method: 'get',
            url: "/SetupReferrals",
            headers: {
            },
            params: { 
              SearchCriteria: parameter.SearchCriteria,             
              PageSize: parameter.PageSize,          
              PageNumber : parameter.PageNumber,           
            }
          }     
          return ApiService.customRequest(requestData);         
        },

      UpdateReferral(id,data){
        return ApiService.put(`/SetupReferrals/${id}`,data);
      },
      AddReferral(data){
        return ApiService.post(`/SetupReferrals/`,data);
      },
      GetReferral(id){
        return ApiService.get(`/SetupReferrals/${id}`);
      },
      DeleteReferral(id){
        return ApiService.delete(`/SetupReferrals/${id}`);
      },

      /** ---------------------------------------------------------- Setup Notes  -----------------------------------------------------*/

      getAllNotes(param){        
        // return ApiService.get(`/SetupNotes/?ProviderCode=${param.ProviderCode}`);
         const requestData = {
            method: 'get',
            url: "/SetupNotes",
            headers: {
            },
            params: { 
              SearchCriteria: param.SearchCriteria,
              ProviderCode:param.ProviderCode,
              Category:param.Category,
              TeleHealth:param.TeleHealth, 
              BillingCode:param.BillingCode, 
              Selected:param.Selected,                        
            //  PageSize: param.PageSize,          
           //   PageNumber : param.PageNumber,           
            }
          }     
          return ApiService.customRequest(requestData); 
      },


      /** ----------------------------------------------- Setup Insurances ---------------------------------------------------------- */

      getAllIsurances(parameter){                 
          const requestData = {
            method: 'get',
            url: "/SetupInsurances",
            headers: {
            },
            params: { 
              TransactionType:parameter.TransactionType,
              Selected:parameter.Selected,
              Category:parameter.Category        
            }
          }     
          return ApiService.customRequest(requestData);         
        },

      GetInsurance(id){
        return ApiService.get(`/SetupInsurances/${id}`);
      },

      UpdateInsurancePrior(id,data){
        return ApiService.put(`/SetupInsurances/${id}`,data);
      },
    
      UpdateSelectedInsurance(data){
        return ApiService.put(`/SetupInsurances/BulkUpdateSelected`,data);
      }

}

export default ISetupService;